import {
  FETCH_CUSTOMERS,
  FETCH_CUSTOMERS_FAILURE,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_INDIVIDUAL_CUSTOMER,
  FETCH_INDIVIDUAL_CUSTOMER_FAILURE,
  FETCH_INDIVIDUAL_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAILURE,
  FETCH_CUSTOMERS_CSV_FAILURE,
  FETCH_CUSTOMERS_CSV_SUCCESS,
  FETCH_CUSTOMERS_CSV,
  CLEAR_CUSTOMER_EXPORT,
  REINSTATE_CONSUMER,
  REINSTATE_CONSUMER_SUCCESS,
  REINSTATE_CONSUMER_FAILURE,
} from './actions';
import { CONSUMERS } from './type';

export const INITIAL_STATE: CONSUMERS.ConsumerReducer = {
  isLoading: 0,
  error: {} as CONSUMERS.Error,
  customers: {} as CONSUMERS.ICustomers,
  individualCustomer: {} as CONSUMERS.IIndividualCustomer,
  removedCustomer: false,
  url: '',
};

const consumerReducer = (
  action: IAction,
  state = INITIAL_STATE
): CONSUMERS.ConsumerReducer => {
  switch (action.type) {
    case FETCH_INDIVIDUAL_CUSTOMER:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        individualCustomer: {} as CONSUMERS.IIndividualCustomer,
        error: {},
      };
    case FETCH_INDIVIDUAL_CUSTOMER_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        individualCustomer: action.payload,
        error: {},
      };
    case FETCH_INDIVIDUAL_CUSTOMER_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        individualCustomer: {} as CONSUMERS.IIndividualCustomer,
        error: { addIndividualCustomer: action.payload.message },
      };
    case FETCH_CUSTOMERS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        customers: {} as CONSUMERS.ICustomers,
        error: {},
      };
    case FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        customers: action.payload,
        error: {},
      };
    case FETCH_CUSTOMERS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { customers: action.payload.message },
      };
    case DELETE_CUSTOMER:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        removedCustomer: false,
        error: {},
      };
    case DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        removedCustomer: true,
        error: {},
      };
    case DELETE_CUSTOMER_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        removedCustomer: false,
        error: { removedCustomer: action.payload },
      };
    case FETCH_CUSTOMERS_CSV:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case FETCH_CUSTOMERS_CSV_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        url: action.payload.url,
        error: {},
      };
    case FETCH_CUSTOMERS_CSV_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { addUrl: action.payload.data },
      };
    case CLEAR_CUSTOMER_EXPORT:
      return {
        ...state,
        url: '',
        error: {
          ...state.error,
          addUrl: undefined,
        },
      };
    case REINSTATE_CONSUMER:
      return { ...state, isLoading: state.isLoading + 1 };
    case REINSTATE_CONSUMER_SUCCESS:
      return { ...state, isLoading: state.isLoading - 1 };
    case REINSTATE_CONSUMER_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {
          ...state.error,
          reinstateConsumer: action.payload.message,
        },
      };
    default:
      return state;
  }
};
export default consumerReducer;
